import React, { memo } from "react";
import * as S from "./styled";
import PT from "prop-types";
import Popup from "./Popup";
import { Map, Layer, Feature, DraggableMarker } from "_c/modules/geo/Map";
import { MARKERS } from "_c/modules/geo/Map/markers";
import { MASTER_SEARCH_RADIUS } from "@/misc/constants";
import { MASTERS_SEARCH_SHOW_MAP_DRAGGABLE_MARKER } from "@/config";

const Masters = memo(({ masters, openMapPopup }) => {
  const { normal, premium } = masters.reduce(
    (acc, master) => {
      acc[
        master.premium || master.saloon_meta?.premium ? "premium" : "normal"
      ].push(master);
      return acc;
    },
    { normal: [], premium: [] },
  );
  return (
    <>
      <Layer type="circle" id="master-normal" paint={MARKERS.secondary}>
        {normal.map(({ location, _id }) => (
          <Feature
            onClick={() =>
              openMapPopup({ coords: location.coordinates, id: _id })
            }
            key={_id}
            coordinates={location.coordinates}
          />
        ))}
      </Layer>
      <Layer
        type="symbol"
        id="master-premium"
        layout={{
          "icon-image": "premium",
          "icon-size": 0.15,
          "icon-ignore-placement": true,
        }}
      >
        {premium.map(({ location, _id }) => (
          <Feature
            onClick={() =>
              openMapPopup({ coords: location.coordinates, id: _id })
            }
            key={_id}
            coordinates={location.coordinates}
          />
        ))}
      </Layer>
    </>
  );
});
Masters.displayName = "MapMasters";

const SearchMap = memo((props) => {
  return (
    <S.Container>
      <Map
        lang={props.locale}
        center={props.mapFocus ? props.mapFocus : [props.lng, props.lat]}
      >
        <Layer
          type="circle"
          id="radius-circle"
          paint={MARKERS.radius({
            radius: props.radius || MASTER_SEARCH_RADIUS,
            lat: props.lat,
          })}
        >
          <Feature coordinates={[props.lng, props.lat]} />
        </Layer>
        <Masters openMapPopup={props.openMapPopup} masters={props.masters} />
        {MASTERS_SEARCH_SHOW_MAP_DRAGGABLE_MARKER && (
          <DraggableMarker
            onDragEnd={props.changeLocation}
            coords={[props.lng, props.lat]}
          />
        )}
        {props.mapPopup && (
          <Popup
            t={props.t}
            onClose={props.closeMapPopup}
            coords={props.mapPopup.coords}
            id={props.mapPopup.id}
          />
        )}
      </Map>
    </S.Container>
  );
});
SearchMap.displayName = "SearchMap";
SearchMap.propTypes = {
  mapPopup: PT.object,
  mapFocus: PT.array,
  masters: PT.array,
  locale: PT.string,
  radius: PT.number,
  lat: PT.number,
  lng: PT.number,

  t: PT.func.isRequired,
  openMapPopup: PT.func.isRequired,
  closeMapPopup: PT.func.isRequired,
  changeLocation: PT.func.isRequired,
};
export default SearchMap;
